import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=719db0a3"
import script from "./DetailsList.vue?vue&type=script&lang=js"
export * from "./DetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports